import clsx from 'clsx';
import React from 'react';
import { CardCourseBodyComponent } from "./card-course-body.component";
import { CardCourseHeaderComponent } from "./card-course-header.component";
import "./card-course.scss";
export const CardCourseDefaultComponents = {
  Header: CardCourseHeaderComponent,
  Body: CardCourseBodyComponent
};
export const CardCourseComponent = props => {
  const {
    Components = CardCourseDefaultComponents,
    data,
    className = 'col-12 col-md-6 col-lg-12 col-xl-6 col-xxl-4 p-4',
    cardClassName = 'text-primary',
    onClick
  } = props;
  const {
    Header = CardCourseDefaultComponents.Header,
    Body = CardCourseDefaultComponents.Body
  } = Components;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('newo-card-course', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('card h-100 bg-transparent border-1 rounded-4 mb-3 text-primary', cardClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header border-0 cursor-pointer",
    onClick: () => onClick && onClick(data)
  }, /*#__PURE__*/React.createElement(Header, {
    data: data,
    onClick: () => onClick && onClick(data)
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-body d-flex flex-column p-3"
  }, /*#__PURE__*/React.createElement(Body, {
    data: data,
    onClick: () => onClick && onClick(data)
  }))));
};